import DownloadPdfExcelUsecase from "@domains/useCases/Reports/CoreReports/DownloadAndSendReports/DownloadPdfExcelUsecase";
import EmailReportUsecase from "@domains/useCases/Reports/CoreReports/DownloadAndSendReports/EmailReportUsecase";
export default (repositories) => ({
    downloadAndSendReportUsecases: {
        donwloadPdfExcel: new DownloadPdfExcelUsecase(repositories.downloadReportsRepo),
        emailReport: new EmailReportUsecase(repositories.downloadReportsRepo),
    },
});
